module.exports = __webpack_public_path__ + "static/media/tapfood.49b94ade.png";